<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field class="email-field">
            <mat-label>Email address</mat-label>
            <input matInput
                   type="email"
                   formControlName="emailAddress">
            <mat-error *ngIf="form.get('emailAddress').hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="form.get('emailAddress').hasError('email')">Please enter a valid email</mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button
            color="accent"
            class="button"
            (click)="onCancel()">
        Cancel
    </button>
    <button mat-flat-button
            color="accent"
            class="button"
            [disabled]="form.invalid"
            (click)="onSubmit()">
        Submit Export
    </button>
</mat-dialog-actions>
